import { render, staticRenderFns } from "./RouteCategories.vue?vue&type=template&id=7bdf155f&"
import script from "./RouteCategories.vue?vue&type=script&lang=js&"
export * from "./RouteCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports